import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchClients as fetchClientsDataApi,
  fetchProjectsAPI,
} from "../../api"; // Import from api.js

// Async thunk for fetching dashboard data
export const fetchProjects = createAsyncThunk(
  "projects/fetchProjects",
  async (_, { rejectWithValue }) => {
    try {
      // Use the function from api.js
      const data = await fetchProjectsAPI();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch dashboard data");
    }
  }
);

const projectSlice = createSlice({
  name: "projects",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    resetError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjects.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjects.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchProjects.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetError } = projectSlice.actions;
export default projectSlice.reducer;
